import createIcon from '../../createIcon';

/**
 * @component @name ExitToApp
 * @description Google Material SVG icon component, renders SVG Element with children.
 *
 * @preview ![img](data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMjQiIGhlaWdodD0iMjQiIHZpZXdCb3g9IjAgMCAyNCAyNCIgZmlsbD0ibm9uZSIgeG1sbnM9Imh0dHA6Ly93d3cudzMub3JnLzIwMDAvc3ZnIj48cGF0aCBkPSJNMTAuMDkgMTUuNTlMMTEuNSAxN0wxNi41IDEyTDExLjUgN0wxMC4wOSA4LjQxTDEyLjY3IDExSDNWMTNIMTIuNjdMMTAuMDkgMTUuNTlaTTE5IDNINUMzLjg5IDMgMyAzLjkgMyA1VjlINVY1SDE5VjE5SDVWMTVIM1YxOUMzIDIwLjEgMy44OSAyMSA1IDIxSDE5QzIwLjEgMjEgMjEgMjAuMSAyMSAxOVY1QzIxIDMuOSAyMC4xIDMgMTkgM1oiIGZpbGw9ImJsYWNrIi8+Cjwvc3ZnPgo=)
 *
 * @param {Object} props - Google Material icons props and any valid SVG attribute
 * @returns {JSX.Element} JSX Element
 *
 */
const ExitToApp = createIcon('ExitToApp', [
  [
    'path',
    {
      d: 'M10.09 15.59L11.5 17L16.5 12L11.5 7L10.09 8.41L12.67 11H3V13H12.67L10.09 15.59ZM19 3H5C3.89 3 3 3.9 3 5V9H5V5H19V19H5V15H3V19C3 20.1 3.89 21 5 21H19C20.1 21 21 20.1 21 19V5C21 3.9 20.1 3 19 3Z',
      key: 'vv7d7c',
    },
  ],
]);

export default ExitToApp;
